import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {useDispatch} from "react-redux";
import {Bar, BarChart, CartesianGrid, Line, XAxis} from "recharts";
import { LineChart, Tooltip } from "recharts";

const useStyles = makeStyles(theme => ({
    mainGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        // backgroundColor: '#434941'
    }
}));

const MiniLineChart = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

   // console.log(props.data);

    /*
    <div className="custom-tooltip">
                    <p className="label">{`${label} : ${payload[0].value}`}</p>
                    <p className="intro">{label}</p>
                    <p className="desc">Anything you want can be displayed here.</p>
                </div>
     */

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length ) {
            return (
                <div className="custom-tooltip">
                    <p className="label">{`${payload[0].payload.data.substr(0,10)}:`}</p>
                    <p className="intro"> {payload[0].value} pneus</p>
                </div>
            );
        }

        return null;
    };


    return (
      <React.Fragment>
          <BarChart width={200} height={100} data={props.data}>
              <Bar dataKey="quantidade" fill="#8d8d8d"  />
              <Tooltip  content={<CustomTooltip />}/>
          </BarChart>
          {/*<LineChart*/}
          {/*    width={200}*/}
          {/*    height={100}*/}
          {/*    data={props.data}*/}
          {/*    margin={{ top: 5, right: 20, left: 10, bottom: 5 }}*/}
          {/*>*/}
          {/*    <XAxis dataKey="name" />*/}
          {/*    <Tooltip  content={<CustomTooltip />}/>*/}
          {/*    <CartesianGrid stroke="#f5f5f5" />*/}
          {/*    <Line type="monotone" dataKey="quantidade" stroke="#387908" yAxisId={1} />*/}
          {/*    <XAxis dataKey="data" />*/}
          {/*</LineChart>*/}
      </React.Fragment>
    );

}

export default (MiniLineChart)
